import '../../modules/mode-components';

import * as angular from 'angular';

import { HomeActionType } from '../../actions/home-actions';
import CreateSpaceModalController from './create-space-modal-controller';
import template from './create-space-modal.html';
import { AccountFacade } from '@mode/accounts/contract';

const renameSpaceDirective = function (Modal, SpaceModel, AlertService, StoreService, AccountFacade: AccountFacade) {
  return {
    restrict: 'A',
    scope: {
      space: '<',
      owner: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.context', (event) => {
        const modal = Modal.open(
          {
            existingSpace: $scope.space,
            owner: $scope.owner,
          },
          {
            controller: CreateSpaceModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );

        modal.result
          .then((space) => {
            $scope.space.name = space.name;
            $scope.space.description = space.description;
            SpaceModel.update($scope.space)
              .then(() => {
                // Update account collections as well after renaming space.
                // This refreshes the navmenu sidebar list of collections.
                // This can move to an effect when space update actions
                // are moved to ngrx.
                AccountFacade.refreshCollections();
                StoreService.dispatch({ type: HomeActionType.RenameSpace, space });
                AlertService.success('Renamed Space');
              })
              .catch(() => AlertService.error('Failed to rename Space'));
          })
          .catch(function () {});
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.context'));
    },
  };
};

renameSpaceDirective.$inject = ['ModalService', 'SpaceModel', 'ToastService', 'StoreService', 'AccountFacade'];

angular.module('mode.components').directive('renameSpace', renameSpaceDirective);
